import React from 'react';
import type { FindingsViewProps } from '@plerionhq/design-system';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';

// The findings page's card list, for any caller's filters.
const FindingsListSlideOverContent = withErrorBoundary(
  React.lazy(
    () =>
      import('../../../micro-frontends/components/findings-list-slide-over-content'),
  ),
);

export const FindingsView = (props: FindingsViewProps) => {
  return <FindingsListSlideOverContent filters={props.data.filters} />;
};
